import { cx } from '@emotion/css';
import PropTypes from 'prop-types';
import React from 'react';
import { InputGroup } from 'react-bootstrap';
import Select from 'react-select';

import asFormField from './asFormField';

const filterOptionByStartsWith = (option, inputValue) => {
    return option.label.toLowerCase().startsWith(inputValue.toLowerCase().trim());
};

export const SelectInput = ({
    name,
    value,
    onChange,
    onBlur,
    onInputChange,
    className,
    style,

    options,
    getOptionValue,
    getOptionLabel,
    placeholder,
    isClearable,
    isLoading,
    disabled,
    isDisabled,
    isMulti,
    addonButton,
    filterOptionType,
    ...rest
}) => {
    const getFilterOption = () => {
        if (filterOptionType === 'startsWith') return filterOptionByStartsWith;
        if (filterOptionType === 'all') return () => true;
        return undefined;
    };
    const controlContent = (
        <Select
            {...rest}
            inputId={name}
            data-testid={`SelectInput-${name}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onInputChange={onInputChange}
            className={cx('form-control react-select', className)}
            style={style}
            // classNamePrefix is necessary for automated tests
            classNamePrefix="react-select"
            options={options}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            placeholder={placeholder}
            isClearable={isClearable}
            isLoading={isLoading}
            isDisabled={disabled || isDisabled}
            isMulti={isMulti}
            filterOption={getFilterOption()}
        />
    );

    if (addonButton) {
        return (
            <InputGroup className="react-select-input-group">
                {controlContent}
                <InputGroup.Append>{addonButton}</InputGroup.Append>
            </InputGroup>
        );
    }

    return controlContent;
};

SelectInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onInputChange: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.shape({}),

    options: PropTypes.arrayOf(PropTypes.shape({})),
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func,
    placeholder: PropTypes.string,
    isClearable: PropTypes.bool,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isMulti: PropTypes.bool,
    addonButton: PropTypes.node,
    filterOptionType: PropTypes.string,
};

SelectInput.defaultProps = {
    value: null,
    onBlur: null,
    onInputChange: null,
    className: '',
    style: null,

    options: [],
    getOptionValue: undefined,
    getOptionLabel: undefined,
    placeholder: undefined,
    isClearable: false,
    isLoading: false,
    disabled: false,
    isDisabled: false,
    isMulti: false,
    addonButton: null,
    filterOptionType: 'contains',
};

const SelectField = asFormField({ WrappedComponent: React.memo(SelectInput) });

export default SelectField;
